import BrowserCheckModal from './BrowserCheckModal';

export default BrowserCheckModal;